import { useInputAmountQuerySync } from '@/hooks/transactionModule/useInputAmountQuery';

import { sellInputSelector, useTradeModuleStore, type TradeModuleStore } from './store';
import { useTradeEngine } from './useTradeEngine';

const updateSellInputSelector = (state: TradeModuleStore) => state.updateSellInput;

/** Connects sell amount query synchronization to rewrite state. */
export function useSellAmountQuerySync(): void {
  const sellInput = useTradeModuleStore(sellInputSelector);
  const updateSellInput = useTradeModuleStore(updateSellInputSelector);
  const { tokenUsdPrices } = useTradeEngine();

  useInputAmountQuerySync({
    sellInput,
    sellTokenUsd: tokenUsdPrices.sellTokenUsd,
    updateSellInput,
  });
}
